// export interface IErrorCodeToMsg {
//   80039: string;
//   85006: string;
// }

export const errorCodeToMsg = {
  80039: "Email address is invalid or already exists.",
  85006: "Invalid email address."
} as any;

// array
// [
//   {
//       "code": 85006,
//       "message": "Invalid emailAddress. Cannot be null, empty string or invalid email based on regex.",
//       "attribute": "emailAddress"
//   },
//   {
//       "code": 85010,
//       "message": "Invalid userName. Cannot be null, empty string, less than 2 characters or exceed 100 characters.",
//       "attribute": "userName"
//   }
// ]

// string
// "Sign up username or password was not provided in the request"

//
// {message: "Endpoint request timed out"}
